<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataset.loading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/centro-custo">Voltar</v-btn>
                    </div>
                    <!-- <div class="button-group">
                        <v-btn type="button" elevation="0" color="primary" @click="add"
                            :loading="dataset.loading">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/passageiros">Voltar</v-btn>
                    </div> -->
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Código" v-model="dataset.data.code" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="6">
                                            <v-autocomplete dense :items="dataset.customers" label="Empresa"
                                                :loading="dataset.customerLoading" required
                                                :search-input.sync="searchCustomer" :rules="[$rules.required]"
                                                v-model="dataset.data.customer_id" item-value="id" item-text="name"
                                                outlined cache-items hide-details="auto"
                                                no-data-text="Nenhuma empresa encontrada" @change="clearSearchField"
                                                :filter="() => true">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

        </v-form>

    </v-container>
</template>

<script>
import axios from "axios"

import debounce from 'lodash/debounce'

export default {
    name: "CostCenterDetails",

    data: () => ({
        page: {
            title: "",
            isNew: false
        },
        dataset: {
            data: {},
            breadcrumbItems: [],
            customers: [],
            loading: false,
            customerLoading: false
        },
        rules: {
            requiredArray: v => (v && v.length > 0) || 'Selecione ao menos uma empresa'
        },
        dataForm: {
            validForm: true,
        },
        searchAddress: null,
        searchCustomer: ''
    }),

    created() {
        this.loadData()
    },

    watch: {
        searchCustomer(val) {
            this.loadCustomers(val);
        },
    },

    methods: {
        goBack() {
            this.$router.replace("/centro-custo");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
        },

        clearSearchField() {
            this.searchPassenger = '';
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Novo centro de custo" : "Detalhes do centro de custo";
        },


        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de centros de custo",
                disabled: false,
                to: "/centro-custo",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? "Incluir centro de custo" : "Detalhes do centro de custo",
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/v2/cost-centers/${this.$route.params.id}`);

                this.dataset.data = result.data.content

                this.dataset.customers = [
                    this.dataset.data.customer
                ]

            } catch (error) {
                console.log('error ', error.toString())
                this.$dialog.notify.error('Ocorreu um erro ao encontrar as informações do centro de custo, tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        loadCustomers: debounce(async function (filter) {

            if (!filter) return;

            this.dataset.customerLoading = true

            try {
                const result = await axios.get(`/api/v2/customers`, { params: { limit: 10, search: { name: filter } } });

                this.$set(this.dataset, 'customers', result.data.content.data)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.customerLoading = false;
            }
        }, 1000),

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o centro de custo?',
                title: 'Incluir centro de custo',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.post('/api/v2/cost-centers', payload);

                this.$dialog.notify.info("Centro de custo salvo com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar os dados do centro de custo?',
                title: 'Atualizar centro de custo',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.patch(`/api/v2/cost-centers/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Centro de custo atualizado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        buildPayload() {

            let data = {
                code: this.dataset.data.code,
                customer_id: this.dataset.data.customer_id
            }


            return data;
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>